module.exports = __webpack_public_path__ + "static/media/logo-banesco.9f770724.svg";